import gql from 'graphql-tag';

const UPDATE_OTA_FIRMWARE = gql`
  mutation Mutation($deviceSerialNo: String!, $OTAFirmwareVersion: String!) {
    updateOTAFirmware(deviceSerialNo: $deviceSerialNo, OTAFirmwareVersion: $OTAFirmwareVersion) {
      code
    }
  }
`;

export default UPDATE_OTA_FIRMWARE;
